/*
 * @Description: 引导页
 * @Author: ZY
 * @Date: 2021-01-21 20:13:03
 * @LastEditors: ZY
 * @LastEditTime: 2021-01-21 21:24:27
 */
import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const HomeRouter: Array<RouteRecordRaw> = [
  {
    path: '/home',
    component: Layout,
    redirect: '/home/index',
    children: [
      {
        path: 'index',
        component: () => import(/* webpackChunkName: "guide" */ '@/views/home/Index.vue'),
        name: 'Home',
        meta: {
          title: 'home',
          icon: '#iconguide'
        }
      },
      {
        path: 'detail',
        component: () => import(/* webpackChunkName: "guide" */ '@/views/home/detail/Index.vue'),
        name: 'Detail',
        meta: {
          title: 'FinancialDetailed',
          icon: '#iconguide'
        }
      }
    ]
  }
]

export default HomeRouter
